import { combineSX } from '@/utils/combineSX';
import { TextField, TextFieldProps } from '@mui/material';
import { FocusEventHandler, useState } from 'react';

export const DpOutlinedInput: React.FC<TextFieldProps> = ({
	error,
	sx,
	onFocus,
	onBlur,
	InputLabelProps,
	...props
}) => {
	const [, setFocused] = useState<boolean>(false);

	const handleFocus: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement> = (event) => {
		setFocused(true);
		onFocus?.(event);
	};

	const handleBlur: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement> = (event) => {
		setFocused(false);
		onBlur?.(event);
	};

	return (
		<TextField
			{...props}
			variant="outlined"
			error={error}
			FormHelperTextProps={{
				sx: { marginLeft: '0px' },
			}}
			InputLabelProps={{
				...InputLabelProps,
				sx: combineSX([
					{ fontSize: 'var(--font-size-body)', lineHeight: '1', height: '20px' },
					InputLabelProps?.sx ?? {},
				]),
			}}
			sx={combineSX([
				{
					'.MuiOutlinedInput-notchedOutline': {
						border: '1px solid #C9C9C9',
						borderRadius: '6px',
					},
					'& .MuiOutlinedInput-root': {
						'&:hover fieldset': {
							borderColor: '#C9C9C9',
						},
						'&.Mui-focused fieldset': {
							borderColor: '#0467D2',
						},
					},
					'& .MuiInputLabel-root': {
						color: error ? '#2C2C2C' : 'initial',
					},
					'.MuiOutlinedInput-input': {
						padding: '14px 14px',
						fontSize: 'var(--font-size-body)',
						height: '20px',
					},
					'& input:-webkit-autofill': {
						WebkitBoxShadow: '0 0 0px 1000px white inset',
					},
					'& .MuiFormHelperText-root': {
						marginLeft: '0px !important',
						fontSize: 'var(--font-size-caption)',
					},
				},
				...(Array.isArray(sx) ? sx : [sx]),
			])}
			onFocus={handleFocus}
			onBlur={handleBlur}
		/>
	);
};
